<template>
    <ClientOnly fallback-tag="span" fallback="Loading images...">
      <Swiper
        ref="swiper"
        :class="['relative', 'w-full', 'max-w-screen-lg', 'overflow-hidden', 'cursor-pointer', 'mb-4']"
        :modules="[SwiperAutoplay, SwiperEffectCreative, SwiperNavigation, SwiperPagination]"
        :autoplay="{
          delay: 8000,
          disableOnInteraction: true,
        }"
        :navigation="{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }"
        :pagination="{
          el: '.swiper-pagination',
          clickable: true,
        }"
        :slides-per-view="count / 2.5"
        :center-insufficient-slides="center"
        :centered-slides-bounds="center"
        :stop-on-last-slide="false"
        :space-between="8"
        :breakpoints="{
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          },
          1536: {
            slidesPerView: 6,
          },
        }">
        <SwiperSlide
          v-for="(picture, index) in props.pictures"
          :key="index"
          :class="count > 2 ? '!w-24' : '!w-36'">
          <nuxt-img
            :class="`rounded-md hover:brightness-50 hover:cursor-pointer ${
              count > 2 ? 'h-24' : 'h-36'
            } object-cover mx-auto`"
            :src="picture.urls ? `${picture.urls.original}&width=200` : `${picture}&width=100`"
            @click="
              $emit(
                'onShow',
                index,
                props.pictures.map((el) => (el.urls ? el.urls.original : el))
              )
            " />
        </SwiperSlide>
      </Swiper>
    </ClientOnly>
  </template>
  
  <script setup>
    const props = defineProps({
      pictures: Array,
      center: Boolean,
    })
    const swiper = ref(null)
    const count = props.pictures.length
    //  function OpenImage(index, array){
    //   const arrayed = array
    //   console.log(index, arrayed, arrayed[index]);
    //  }
  </script>
  
  <style scoped>
    .swiper-button-next:after,
    .swiper-button-prev:after {
      color: #c54b38;
      font-size: 34px;
      font-weight: 800;
      text-shadow: 0px 1px 4px #620d0d;
    }
  
    .swiper-button-next,
    .swiper-rtl .swiper-button-prev {
      right: 0;
      left: auto;
      height: 100%;
      top: auto;
      background: linear-gradient(270deg, #ffffff, #ffffff6b);
      z-index: 50;
      width: 35px;
    }
  
    .swiper-button-prev,
    .swiper-rtl .swiper-button-next {
      left: -1;
      left: auto;
      height: 100%;
      top: auto;
      background: linear-gradient(90deg, #ffffff, #ffffff6b);
      z-index: 50;
      width: 35px;
    }
  
    .swiper-slide {
      padding-top: 10px;
    }
  </style>
  